<div class="flex-fill d-flex flex-column">
    <div class="m-1 grid-fill" *ngIf="jobs">
        <dx-data-grid
            #dataGrid
            [dataSource]="jobs"
            keyExpr="id"
            [columnAutoWidth]="false"
            (onToolbarPreparing)="onToolbarPreparing($event)"
            (onSelectionChanged)="selectionChange($event)"
            (onCellDblClick)="rowDoubleClick($event)"
            (onOptionChanged)="onOptionChanged($event)"
            (onContentReady)="onContentReady($event)"
            (onRowPrepared)="rowPrepare($event)"
        >
            <dxi-column dataField="jobNumber" caption="Job #" width="80" cellTemplate="linkTemplate"></dxi-column>
            <dxi-column dataField="customerName" caption="Customer" width="200"></dxi-column>
            <dxi-column dataField="description" caption="Description" width="200"></dxi-column>
            <dxi-column dataField="keyCode" width="100"></dxi-column>
            <dxi-column dataField="note" caption="Notes" width="100"></dxi-column>
            <dxi-column dataField="jobType.name" caption="Job Type" width="100"></dxi-column>
            <dxi-column dataField="status.name" caption="Status" width="100"></dxi-column>
            <!-- <dxi-column dataField="locationAddress" caption="Location" width="100"></dxi-column> -->
            <dxi-column dataField="created" caption="Create Date" type="date" width="100"></dxi-column>

            <div *dxTemplate="let cell of 'linkTemplate'">
                <a [routerLink]="[]" (click)="addJob(cell.data)">{{ cell.value || '(blank)' }}</a>
            </div>
            <div *dxTemplate="let item of 'columnTemplate'">
                <div style="font-weight: bold">{{ item.data.shipToLocation }}</div>
                <div>{{ item.data.shipToAddress1 }}</div>
                <div [hidden]="!item.data.shipToAddress2">{{ item.data.shipToAddress2 }}</div>
                <div>{{ item.data.shipToCity }}, {{ item.data.shipToState }} {{ item.data.shipToZip }} {{ item.data.shipToCountry }}</div>
            </div>

            <dxo-search-panel class="d-none d-sm-block" [visible]="true"></dxo-search-panel>
            <dxo-export [enabled]="true" [allowExportSelectedData]="true"></dxo-export>
            <dxo-filter-row [visible]="true"></dxo-filter-row>
            <dxo-state-storing [enabled]="true" type="localStorage" storageKey="job-search-grid"></dxo-state-storing>
            <dxo-selection [mode]="'multiple'"></dxo-selection>

            <div *dxTemplate="let data of 'toolbarButtons'">
                <button class="btn btn-success" (click)="open(dataGrid.instance.getSelectedRowsData()[0].id)" [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1">
                    Open
                </button>
                <button class="btn btn-success ml-2" (click)="addJob(dataGrid.instance.getSelectedRowsData()[0])" [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1">
                    Edit
                </button>
                <button class="btn btn-secondary ml-2" (click)="addJob()">New</button>
                <button
                    class="btn btn-danger ml-2"
                    (click)="delete(dataGrid.instance.getSelectedRowsData()[0])"
                    [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1"
                    [hidden]="!auth.hasRole('JobAdmin') && !auth.hasRole('Admin')"
                >
                    Delete
                </button>
                <!-- <button
                    class="btn btn-primary ml-2"
                    (click)="updateStatus()"
                    [disabled]="dataGrid.instance.getSelectedRowsData().length === 0 || true"
                >
                    Update Status
                </button> -->
                <button
                    class="btn btn-primary ml-2"
                    (click)="completeJobs()"
                    [disabled]="dataGrid.instance.getSelectedRowsData().length === 0"
                    [hidden]="!auth.hasRole('JobAdmin') && !auth.hasRole('Admin')"
                >
                    Complete
                </button>
                <button
                    class="btn btn-secondary ml-2"
                    (click)="editJobType(dataGrid.instance.getSelectedRowsData())"
                    [disabled]="dataGrid.instance.getSelectedRowsData().length == 0"
                >
                    Edit Job Type
                </button>
                <button type="button" (click)="toggleShowActive()" class="btn btn-sm btn-warning ml-3">{{ showActiveJobs ? 'Show All' : 'Show Active' }}</button>
            </div>
            <div *dxTemplate="let data of 'toolbarText'">
                <span *ngIf="jobs" class="mr-3"
                    ><strong>{{ dataGrid.instance.totalCount() + ' items' }}</strong></span
                >
            </div>
        </dx-data-grid>
    </div>
</div>
